import { Component, ChangeDetectionStrategy, Input } from '@angular/core';


import {Yii} from "libraries/interfaces/Yii";

@Component({
    selector: 'date-range',
    template: `
    <ng-container *ngIf="startDate && endDate && areSameDay || startDate && !endDate">
        <time>{{ startDate | dateMoment: dateFormat.momentShort }}</time>
    </ng-container>
    <ng-container *ngIf="startDate && endDate && !areSameDay">
        {{ labels.from }} <time>{{ startDate | dateMoment: dateFormat.momentShort }}</time>
        {{ labels.to }} <time>{{ endDate | dateMoment: dateFormat.momentShort }}</time>
    </ng-container>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateRangeComponent {
    @Input()
    public set start(value: Date | string){
        this.startDate = this.parseValue(value);
        this.areSameDay = this.computeIfDatesAreOnSameDay(this.startDate, this.endDate);
    }

    @Input()
    public set end(value: Date | string){
        this.endDate = this.parseValue(value);
        this.areSameDay = this.computeIfDatesAreOnSameDay(this.startDate, this.endDate);
    }

    public startDate: Date;
    public endDate: Date;
    public areSameDay: boolean;

    public dateFormat = JSON.parse(sessionStorage.getItem('dateFormat'));
    public labels = {
        from: Yii.t('wui-sasha-js', 'du'),
        to: Yii.t('wui-sasha-js', 'au')
    };

    private parseValue(value: Date | string): Date{
        if (!value){
            return undefined;
        }

        if (value instanceof Date){
            return value;
        }

        return new Date(value);
    }

    private computeIfDatesAreOnSameDay(start: Date, end: Date): boolean{
        if (!start){
            return !end;
        }else if (!end){
            return false;
        }

        return start.getFullYear() === end.getFullYear()
            && start.getMonth() === end.getMonth()
            && start.getDate() === end.getDate();
    }
}